import "./CertificateGroupingGWPConcrete.scss";
import CertificateGroupingListGWPConcreteFinalReviewForm from "../../features/CertificateGroupingListGWPConcreteFinalReviewForm/CertificateGroupingListGWPConcreteFinalReviewForm";

const CertificateGroupingGWPConcreteForFinalReview = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListGWPConcreteFinalReviewForm />
    </div>
  );
};

export default CertificateGroupingGWPConcreteForFinalReview;
